/**
 * flore.SER na loja — bloco do carrinho e linha da página de produto.
 *
 * Fala com a function floreser-proxy pelo App Proxy: /apps/floreser
 * A API devolve tudo formatado; aqui só se desenha e se escuta o deslizante.
 *
 * O carrinho é redesenhado pelo tema a cada mudança de item, então a inicialização
 * é idempotente e roda de novo em cada render.
 */
(function () {
  'use strict';

  var API = '/apps/floreser';

  function api(acao, corpo) {
    var o = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ acao: acao }, corpo || {}))
    };
    return fetch(API + '?acao=' + encodeURIComponent(acao), o).then(function (r) {
      return r.json().catch(function () { return { ok: false, error: 'resposta inesperada do servidor' }; });
    });
  }

  var ver = function (el, sim) { if (el) el.hidden = !sim; };

  function iniciarCarrinho(raiz) {
    if (raiz.__jbf) return;
    raiz.__jbf = true;

    var q = function (s) { return raiz.querySelector(s); };
    var subtotal = parseInt(raiz.getAttribute('data-jbfc-subtotal') || '0', 10);

    var range = q('[data-jbfc-range]');
    var criar = q('[data-jbfc-criar]');
    var confirma = q('[data-jbfc-confirma]');
    var erro = q('[data-jbfc-erro]');
    var dados = null;

    function mostrarErro(t) {
      if (!t) { ver(erro, false); return; }
      erro.textContent = t;
      ver(erro, true);
    }

    function pintarTrilho() {
      var pct = range.max > 0 ? (range.value / range.max) * 100 : 0;
      range.style.setProperty('--jbf-pct', pct + '%');
    }

    function atualizarEscolha() {
      var polens = parseInt(range.value, 10) || 0;
      var reais = polens * (dados.valor_por_polen || 0.05);
      q('[data-jbfc-escolha]').textContent =
        polens.toLocaleString('pt-BR') + (polens === 1 ? ' pólen' : ' pólens');
      q('[data-jbfc-desconto]').textContent =
        reais.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      criar.disabled = polens < (dados.passo || 20);
      pintarTrilho();
      ver(confirma, false);
      ver(criar, true);
    }

    function desenharPronto(ja) {
      ver(q('[data-jbfc-usar]'), false);
      ver(q('[data-jbfc-pronto]'), true);
      q('[data-jbfc-pronto-txt]').innerHTML =
        'desconto de <b>' + (ja.valor_texto || '') + '</b> criado com ' + (ja.polens_texto || '') +
        '. código <b>' + (ja.codigo || '') + '</b>.';
      var bt = q('[data-jbfc-aplicar]');
      bt.setAttribute('href', ja.url_aplicar || '#');
    }

    function desenhar(d) {
      dados = d;
      mostrarErro(null);

      if (!d.participa) {
        q('[data-jbfc-saldo]').textContent = '';
        ver(q('[data-jbfc-convite]'), true);
        return;
      }

      ver(q('[data-jbfc-convite]'), false);
      q('[data-jbfc-saldo]').textContent =
        (d.saldo && d.saldo.polens_texto ? d.saldo.polens_texto : '') +
        (d.saldo && d.saldo.valor_texto ? ' · ' + d.saldo.valor_texto : '');

      if (d.rende && d.rende.texto) {
        q('[data-jbfc-rende]').textContent = d.rende.texto;
        ver(q('[data-jbfc-rende]'), true);
      }

      if (d.ja_aplicado) { desenharPronto(d.ja_aplicado); return; }

      var max = d.max_polens || 0;
      var passo = d.passo || 20;
      if (max < passo) return;

      range.min = 0;
      range.max = max;
      range.step = passo;
      range.value = 0;
      q('[data-jbfc-teto]').textContent = d.teto_texto || '';
      q('[data-jbfc-aviso]').textContent =
        d.aviso || 'Os pólens saem do seu saldo no momento em que você cria o desconto.';
      ver(q('[data-jbfc-usar]'), true);
      atualizarEscolha();
    }

    range.addEventListener('input', atualizarEscolha);

    criar.addEventListener('click', function () {
      ver(criar, false);
      ver(confirma, true);
      q('[data-jbfc-confirmar]').focus();
    });

    q('[data-jbfc-cancelar]').addEventListener('click', function () {
      ver(confirma, false);
      ver(criar, true);
      criar.focus();
    });

    q('[data-jbfc-confirmar]').addEventListener('click', function () {
      var bt = this;
      bt.disabled = true;
      bt.textContent = 'criando…';
      mostrarErro(null);
      api('resgatar_carrinho', {
        polens: parseInt(range.value, 10),
        subtotal_centavos: subtotal
      }).then(function (r) {
        bt.disabled = false;
        bt.textContent = 'confirmar';
        if (r && r.ok) {
          ver(confirma, false);
          desenharPronto(r);
          if (r.url_aplicar) window.location.href = r.url_aplicar;
          return;
        }
        if (r && r.ja_aplicado) { ver(confirma, false); desenharPronto(r.ja_aplicado); return; }
        ver(confirma, false);
        ver(criar, true);
        mostrarErro((r && r.error) || 'não deu para criar o desconto agora. seus pólens continuam com você.');
      }).catch(function () {
        bt.disabled = false;
        bt.textContent = 'confirmar';
        mostrarErro('não deu para falar com o servidor. seus pólens continuam com você.');
      });
    });

    api('carrinho', { subtotal_centavos: subtotal })
      .then(function (d) {
        // 400 com participa:false é resposta legítima: a cliente ainda não entrou no programa
        if (d && (d.ok !== false || typeof d.participa === 'boolean')) desenhar(d);
      })
      .catch(function () { });
  }

  var produtoCache = null;

  function iniciarProduto(el) {
    if (el.__jbf) return;
    el.__jbf = true;

    var centavos = parseInt(el.getAttribute('data-jbfp-preco') || '0', 10);
    if (!centavos) return;

    function desenhar(d) {
      var taxa = d.polens_por_real_efetivo || d.polens_por_real_base || 0;
      if (!taxa) return;
      var polens = Math.floor((centavos / 100) * taxa);
      if (polens < 1) return;

      el.querySelector('[data-jbfp-num]').textContent =
        polens.toLocaleString('pt-BR') + (polens === 1 ? ' pólen' : ' pólens');

      var nota = el.querySelector('[data-jbfp-nota]');
      if (d.logada && d.multiplicador_texto && d.multiplicador > 1) {
        nota.textContent = 'no seu nível ' + (d.nivel_nome || '');
      } else if (!d.logada) {
        nota.innerHTML = '<a href="/pages/flore-ser">participe e renda mais</a>';
      } else {
        nota.textContent = '';
      }
      el.hidden = false;
    }

    if (produtoCache) { desenhar(produtoCache); return; }
    api('produto', {})
      .then(function (d) {
        if (!d || d.ok === false) return;
        produtoCache = d;
        desenhar(d);
      })
      .catch(function () { });
  }

  function varrer() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-jbfc]'), iniciarCarrinho);
    Array.prototype.forEach.call(document.querySelectorAll('[data-jbfp]'), iniciarProduto);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varrer);
  } else {
    varrer();
  }

  var alvo = document.getElementById('CartDrawer');
  if (alvo && 'MutationObserver' in window) {
    var pendente = null;
    new MutationObserver(function () {
      clearTimeout(pendente);
      pendente = setTimeout(varrer, 120);
    }).observe(alvo, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', varrer);
})();
